import { createContext } from "react";

// cart-context wordt gebruikt in: Cart, HeaderCartButton, CryptoItem
const CartContext = createContext({
  items: [],
  totalAmount: 0,
  addItem: (item) => {},
  removeItem: (id) => {},
  clearCart: () => {},
});

export default CartContext;